<template>
	<div class="empty">
		<img :src="'../../../static/icon/' + img + '.png' " >
		<div :style="{color,fontSize:fontSize + 'px'}">{{title}}</div>
	</div>
</template>

<script>
	/* 
	 *  img 			图片名字
	 *	title 		提示文字
	 *	color 		提示字体颜色
	 *	fontSize 	提示字体大小
	 */
	export default{
		name:'empty',
		data(){
			return{
				
			}
		},
		props:{
			img:{
				type:String,
				default:'live-empty'
			},
			title:{
				type:String,
				default:'暂无直播'
			},
			color:{
				type:String,
				default:'#FFD6B1'
			},
			fontSize:{
				type:String,
				default:'16'
			}
		}
	}
</script>

<style lang="scss" scoped>
	.empty{
		text-align: center;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/global/empty.vue